import React, {useState, useRef, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import './BurgerMenu.css';
import {Heading} from "../Heading";

const CHIPS = [
    {id: 'OurPlus', tKey: 'header.chip_1', tCount: '4'},
    {id: 'Feature', tKey: 'header.chip_2', tCount: '3'},
    {id: 'WhyUs', tKey: 'header.chip_3', tCount: '4'},
    {id: 'Case', tKey: 'header.chip_4', tCount: '5'},
    {id: 'pricing', tKey: 'header.chip_5', tCount: '3'},
    {id: 'FAQ', tKey: 'header.chip_6', tCount: '9'},
];

export default function BurgerMenu() {
    const [open, setOpen] = useState(false);
    const {t} = useTranslation();
    const navigate = useNavigate();
    const ref = useRef<HTMLDivElement>(null);

    // Закрываем дропдаун при клике вне
    useEffect(() => {
        const onClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', onClickOutside);
        return () => document.removeEventListener('mousedown', onClickOutside);
    }, []);

    const handleItemClick = (
        e: React.MouseEvent<HTMLAnchorElement>,
        targetId: string
    ) => {
        e.preventDefault();
        if (window.location.pathname === '/landing') {
            const el = document.getElementById(targetId);
            if (el) el.scrollIntoView({behavior: 'smooth', block: 'start'});
        } else {
            navigate('/landing', {state: {targetId}});
        }
        setOpen(false);
    };

    return (
        <div className="relative" ref={ref}>
            <div
                className="w-8 h-8 flex items-center justify-center cursor-pointer"
                onClick={() => setOpen(v => !v)}
            >
                <img
                    src={open ? "/images/burgerMenuClose.svg" : "/images/headerBurgerIcon.svg"}
                    alt={open ? "Close menu" : "Open menu"}
                />
            </div>
            {open && (
                <div className="tui-dropdown absolute right-0 mt-2">
                    {CHIPS.map(({id, tKey, tCount}) => (
                        <a
                            key={id}
                            href={`#${id}`}
                            className="tui-dropdown-item"
                            onClick={(e) => handleItemClick(e, id)}
                        >
                            <div className={"flex flex-row justify-between w-full"}>
                                <Heading className="label">
                                    {t(tKey)}
                                </Heading>
                                <div className="gap-2 flex flex-row">
                                    <Heading
                                        size="desktop_body_s"
                                        className="rounded-full bg-[#79818C1F] w-6 h-6 text-center">
                                        {t(tCount)}
                                    </Heading>
                                    <img
                                        src={"/images/dropdownArrowLeft.svg"}
                                        alt="leftArrow"
                                        className="m-auto"/>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
}
